import { useAlertStore } from '@/store/alert'

export function useEtgClipboard() {
  const alertStore = useAlertStore()

  const { t } = useI18n()
  const { copy } = useClipboard({ legacy: true })

  function doCopy(copyText?: Nullable<string>, successMsg: Nullable<string> = t('general.copy_success')) {
    if (!copyText) {
      return
    }

    copy(copyText)

    if (successMsg) {
      alertStore.success(successMsg)
    }
  }

  return { doCopy }
}
